export const PLATFORM_ADMIN_HOSTS = new Set([
  'admin.gesty.tn',
  // Kept during the lyfty.agency → gesty.tn transition (old domain left live).
  'admin.lyfty.agency',
]);

export function isPlatformAdminHost(hostname?: string): boolean {
  const value =
    hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');
  return PLATFORM_ADMIN_HOSTS.has(value.toLowerCase());
}

export function isPlatformAdminPath(pathname?: string): boolean {
  const value =
    pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  return value === '/platform' || value.startsWith('/platform/');
}

export function isPlatformAdminMode(): boolean {
  if (typeof window === 'undefined') return false;
  return isPlatformAdminHost() || isPlatformAdminPath();
}
